import { useCallback } from 'react'

import { useIsAiNotetakerEnabled } from 'features/meeting_intelligence'

import { buildBookingPageSharedProperties } from './bookingPageSharedProperties'
import { TRACKING_EVENT_NAMES } from './constants'
import { useTrack } from './useTrack'

/**
 * Shared hook for firing BOOKING_PAGE_SHARED events.
 * Automatically injects is_ai_notetaker_enabled when applicable.
 *
 * @param {number | undefined} [eventTypeId] - Event type ID for notetaker check
 * @returns {(properties: Object, options?: { version?: number }) => void}
 */
export const useTrackBookingPageShared = (eventTypeId) => {
  const track = useTrack()
  const isAiNotetakerEnabled = useIsAiNotetakerEnabled(eventTypeId)

  return useCallback((properties, { version = 2 } = {}) => {
    track({
      name: TRACKING_EVENT_NAMES.BOOKING_PAGE_SHARED,
      version,
      properties: buildBookingPageSharedProperties(properties, isAiNotetakerEnabled)
    })
  }, [track, isAiNotetakerEnabled])
}
